module.exports = __webpack_public_path__ + "static/media/Search_Icon.2fb0f36c.svg";